import SystemLayoutUiService from "app/Service/System/Layout/SystemLayoutUiService"
import React from "react"
import {Button} from "react-bootstrap"
import {useNavigate} from "react-router-dom"
import WebPathService, {OPERATION_SETTINGS, SubWebPathService} from "app/Service/System/WebPathService"

const ExitEditLayoutButton = () => {

  let navigate = useNavigate()

  const {modulePath} = WebPathService([
    SubWebPathService.modulePath,
    SubWebPathService.operation
  ], 'ShowLayoutButtons')

  const {setEditLayout} = SystemLayoutUiService([] ,'ExitEditLayoutButton')

  function exitLayoutConfiguration() {
    setEditLayout(undefined)
    navigate(`/${modulePath}/${OPERATION_SETTINGS}`)
  }

  return (
    <Button
      onClick={() => exitLayoutConfiguration()}
      variant={'primary'}
    >
      Exit
    </Button>
  )
}

export default ExitEditLayoutButton
